import React, { Component } from 'react';
import './Page.css';

import cookie from 'react-cookies';

import Notification from '../components/Notification';

import Cart from '../components/Cart';
import Checkout from '../components/Checkout';

import { API_BASE } from '../config';

import RSClogo from '../images/RSS_logo-dark.svg';

class CartAndCheckout extends Component {

  constructor(props) {
    super(props);

    this._addProduct = this._addProduct.bind(this);
    this._checkForShipping = this._checkForShipping.bind(this);
    this._emptyCart = this._emptyCart.bind(this);
    this._getCart = this._getCart.bind(this);
    this._getStore = this._getStore.bind(this);

    this.state = {
      cart:null,
      notification_text:"",
      shipping:false,
      store_permalink:this.props.params.storePermalink ? this.props.params.storePermalink.toLowerCase() : "", // make it lowercase to prevent doubling up on cart tokens in cookies
      store:null
    };

  }

  componentDidMount() {

    this._getStore(); // getStore > getCart/addCart > addProduct

  }

  render() {
    
      var storeLogo = "";
      if (this.state.store && this.state.store.logo_url) {
        storeLogo = <span><img src={this.state.store.logo_url} alt={this.state.store.name} /> &nbsp; &times; &nbsp; </span>
      } else if (this.state.store && this.state.store.name) {
        storeLogo = <span><strong>{this.state.store.name}</strong> &nbsp; &times; &nbsp; </span>
      }

      return (
        <div>
          <Notification text={this.state.notification_text} />
          <ul className="App-menu">
            <li className="logo">
              {storeLogo}
              <img src={RSClogo} alt="Really Simple Store" />
            </li>
            <li>Total <strong>${this.state.cart && this.state.cart.totals ? this.state.cart.totals.total : "0"}</strong><ul>
              <li><strong>{this.state.store ? this.state.store.name : null}</strong></li>
              <li><a onClick={this.refs.checkout ? this.refs.checkout._toggleFixed : null}>Checkout now for ${this.state.cart && this.state.cart.totals ? this.state.cart.totals.total : "0"}</a></li>
              <li><a href={this.state.store ? "//shop.reallysimplestore.com/"+this.state.store.permalink : null}>← Back to Store</a></li>
              <li><a href={this.state.store ? "mailto:"+this.state.store.email : null}>Contact Seller</a></li>
              <li>&nbsp;</li>
              <li><a href="https://reallysimplestore.com">What is Really Simple Store?</a></li>
            </ul></li>
          </ul>

          <div className="App-BackBar" onClick={this.props.router.goBack}>
            <p>← Back to store</p>
          </div>

          <div className="App-pages">
            
            <Cart cart={this.state.cart} store={this.state.store} updateCart={this._getCart} shipping={this.state.shipping} />
            
            <Checkout ref="checkout" store={this.state.store} store_permalink={this.state.store_permalink} cart={this.state.cart} emptyCart={this._emptyCart} shipping={this.state.shipping} />
            
          </div>
        </div>
      );
  
  }

  _addProduct() { // adds a product if url parameters are set (otherwise does nothing)

    var _this = this;

    if (this.props.params.productid > 0) {
      var product_id = this.props.params.productid;
      var quantity = this.props.params.quantity || 1;

      var cart_token = cookie.load(_this.state.store_permalink);

      var request = new Request(`${API_BASE}cart/add/`+product_id+"/"+quantity+"?cart_token="+cart_token, {
        method: 'PUT', 
        mode: 'cors'
      });

      /*_this.setState({
        notification_text:"Updating cart..."
      });*/
      fetch(request).then(function(response) {
        return response.json();
      }).then(function(json) {
        //console.log('parsed json', json);
        
        _this.props.router.replace('/'+_this.state.store_permalink); // remove add/ from url so it stops adding

        _this.setState({
          notification_text:json.success ? _this.state.notification_text : json.error
        },
        _this._getCart);

        cookie.save(_this.state.store_permalink,json.cart_token,{ path : '/'});
        cookie.save(_this.state.store_permalink,json.cart_token,{ path : '/', domain : 'reallysimplestore.com'});

      }).catch(function(ex) {
        console.log('parsing failed', ex);
      });
    }

  }

  _emptyCart() {
    this.setState({
      cart:{cart:[],totals:{total:0}}
    });
    cookie.remove(this.state.store_permalink,{ path : '/'});
    cookie.remove(this.state.store_permalink,{ path : '/',domain : 'reallysimplestore.com'});
  }

  _getCart() {

    var _this = this;

    if (cookie.load(_this.state.store_permalink)) { //  GET CART

      var cart_token = cookie.load(_this.state.store_permalink);

      var request = new Request(`${API_BASE}cart?cart_token=`+cart_token, {
        method: 'GET', 
        mode: 'cors'
      });

      fetch(request).then(function(response) {
        return response.json();
      }).then(function(json) {
        //console.log('parsed json', json);
        
        if (!json.cart) {
          json.cart = {cart:[],totals:{total:0}};
        }

        _this.setState({
          cart:json
        });

        cookie.save(_this.state.store_permalink,json.cart_token,{ path : '/'});
        cookie.save(_this.state.store_permalink,json.cart_token,{ path : '/',domain : 'reallysimplestore.com'});

        _this._addProduct();
        _this._checkForShipping();
        _this._setColors();

      }).catch(function(ex) {
        console.log('parsing failed', ex);
      });

    } else { // ADD CART

      var request = new Request(`${API_BASE}carts?store_id=`+_this.state.store.id, {
        method: 'POST', 
        mode: 'cors'
      });

      fetch(request).then(function(response) {
        return response.json();
      }).then(function(json) {
        //console.log('parsed json', json);
        
        _this.setState({
          cart:{cart:[],totals:{total:0}}
        });

        cookie.save(_this.state.store_permalink,json.cart_token,{ path : '/'});
        cookie.save(_this.state.store_permalink,json.cart_token,{ path : '/',domain : 'reallysimplestore.com'});

        _this._addProduct();

      }).catch(function(ex) {
        console.log('parsing failed', ex);
      });

    }

  }

  _getStore() {
    var _this = this;

    var request = new Request(`${API_BASE}store/`+_this.state.store_permalink, {
      method: 'GET', 
      mode: 'cors'
    });

    fetch(request).then(function(response) {
      return response.json();
    }).then(function(json) {
      //console.log('parsed json', json);

      // set state
      _this.setState({
        store:json
      },function() {
        _this._getCart();
        _this._setColors();
      });

    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

  _setColors() {

    // main colors
    var domGroup = document.querySelectorAll(".App-BackBar,.App-menu > li > ul,button,.cartRow-info.cartRow-info-alt,.Notification-Overlay,.Notification-Overlay.hidden");
    for (var i = 0; i < domGroup.length; i++) {
      domGroup[i].style.backgroundColor = this.state.store.color_main;
    }

    // secondary colors
    var domGroup = document.querySelectorAll(".App-BackBar,.App-menu > li > ul,.App-menu > li > ul a,.App-menu > li > ul > li,button,.cartRow-info.cartRow-info-alt,.cartRow-info.cartRow-info-alt a");
    for (var i = 0; i < domGroup.length; i++) {
      domGroup[i].style.color = this.state.store.color_secondary;
    }

  }

  _checkForShipping() {

    var shipping = false;
    if (this.state.cart) {
      this.state.cart.cart.forEach(function(e) {
        if (e.shipping_required > 0) { shipping = true; return true; }
      });
    }

    this.setState({
      shipping:shipping
    })

  }

}

export default CartAndCheckout;



// WEBPACK FOOTER //
// ./src/pages/CartAndCheckout.js